import React, { FC, useEffect } from 'react'
import MainLayout from '../main-layout/main-layout';
import { UserHelp } from '@components/';
import { BasePresenter } from '@presenters/base/base.presenter';

const Admin: FC<any> = () => {

    const presenter = new BasePresenter();

    //useEffect(() => {
    //    presenter.validateUserInfo();
    //}, [presenter.currentUser]);

    return (
        <MainLayout>
            <UserHelp></UserHelp>
        </MainLayout>);
}
export default Admin;